import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Login from "../pages/Login";
import MainLayout from "../MainLayout";
import Signup from "../pages/Signup";
import About from "../pages/footer/About";
import Cart from "../pages/Cart"
// Offers page is disabled for now — launch-blocker fix: it was an empty
// stub with no backend integration, linked from Header/Banner but showing
// nothing. Commented out (not deleted) so it's easy to re-enable once the
// admin-managed offers are actually wired up to a page. See Header.js and
// Banner.js for the matching commented-out entry points.
// import Offers from "../pages/Offers"
import SpecificProductPage from "../pages/SpecificProductPage";
import PlaceOrder from "../pages/PlaceOrder";
import SpecificCategory from "../pages/SpecificCategory";
import TermsConditions from "../pages/footer/TermsConditions";
import PrivacyPolicy from "../pages/footer/PrivacyPolicy";
import Support from "../pages/footer/Support";
import ForgotPassword from "../pages/ForgotPassword";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "/",
                element: <MainLayout />
            },
            {
                path: "/login",
                element: <Login />
            },
            {
                path: "/signup",
                element: <Signup />
            },
            {
                path: "/cart",
                element: <Cart />
            },
            // Offers route disabled along with the import above — see comment there.
            // {
            //     path: "/offers",
            //     element: <Offers />
            // },
            {
                path: "/product/:product",
                element: <SpecificProductPage />
            },
            {
                path: "/category/:category",
                element: <SpecificCategory />
            },
            {
                path: "/place-order",
                element: <PlaceOrder />
            },
            {
                path: "/about",
                element: <About />
            },
            {
                path: "/terms_conditions",
                element: <TermsConditions />
            },
            {
                path: "/support",
                element: <Support />
            },
            {
                path: "/privacy_policy",
                element: <PrivacyPolicy />
            },
            {
                path: '/forgot-password',
                element: <ForgotPassword />
            }
        ]
    }
])